// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2fFWC","type":"styles_type___zRDc","choices":"styles_choices__C5W2m"};